import { NgRedux, select } from '@angular-redux/store';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { Email } from '../customer.model';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { AppState } from '../../../store/state.model';
import { NgIf } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-guid-alignment',
    templateUrl: './guid-alignment.component.html',
    styleUrls: ['./guid-alignment.component.scss'],
    imports: [NgIf, MatTooltip, MatIcon, TranslatePipe]
})
export class GuidAlignmentComponent implements OnInit, OnChanges, OnDestroy {
  /**
   * @property Property contains emails information
   */
  @Input() emails: Array<Email>;
  /**
   * @property Property to store guid from input
   */
  @Input() guid: string;
  /**
   * @property Property to store vehicle info
   */
  public vehicle: object;
  /**
   * @property Property to store customerCentral display flag
   */
  public customerCentralFlag = true;
  /**
   * @property Property to store subscription display flag
   */
  public subscriptionFlag = true;
  /**
   * @property Property to show feature
   */
  public showGuidAlignment: boolean;
  /**
 * @property Property to store the flag for  multiple guids
 */
  public isCCMultipleGuid: boolean;
  /**
   * @property guids
   */
  public guids: {
    azureGuid: string;
    customerCentralGuid: string;
    forgeRockGuid: string;
    ocprGuid: string;
    subscriptionGuid: string;
    customerCentralMultipleGuids: string;
  };

  /**
   * @Property to observe the redux customer store
   **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;

  apiSubscription: Subscription;

  constructor(
    public translate: TranslationService,
    public orch: OrchestrationService,
    private ngRedux: NgRedux<AppState>,
  ) {
    this.showGuidAlignment = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const customerEmail = this.emails ? this.emails.find(
      (email) => !!email.emailAddress
    ) : null;
    if (!!customerEmail) {
      this.orch.getGuidStatus(customerEmail.emailAddress);
    } else {
      this.showGuidAlignment = false;
    }
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit() {
    this.apiSubscription = this.apiObservable.subscribe((api) => {
      this.setGuids(api);
    });
  }
  /**
   * @function ngOnDestroy Method to clean when component exit from view and make a clean room after a new visit
   */
  ngOnDestroy(): void {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
  }
  /**
   * @function setGuids Method to set the customer guids list
   * @param api of ApiResponseState type
   */
  public setGuids(api: ApiResponseState) {
    if (api.apiAction === ApiResponseActions.SET_GUID_STATUS) {
      if (api.guidStatus['type'] === 'success') {
        this.showGuidAlignment = true;
        this.setCCMultipleGuids(api);
      } else {
        this.showGuidAlignment = false;
      }
    }
    this.setVehicleInfo();
  }

  /**
   * @function setCCMultipleGuids sets CCMultipleGuids list into guids if exist
   * @param api of ApiResponseState type
   * @returns void
   */
  public setCCMultipleGuids(api: ApiResponseState): void {
    const multipleGuids = [];
    this.guids = api.guidStatus['payload'].accountDetails;
    this.guids['customerCentralGuid'] = !!this.guids['ccUserDetails'] ? this.guids['ccUserDetails']['ccGuids'][0] : '';
    this.guids['forgeRockGuid'] = !!this.guids['frUserDetails'] && this.guids['frUserDetails']['guid'];
    this.guids['ocprGuid'] = !!this.guids['ocprUserDetails'] && this.guids['ocprUserDetails']['guid'];
    this.guids['subscriptionGuid'] = !!this.guids['subscriptionUserDetails'] && this.guids['subscriptionUserDetails']['guid'];
    if (!!this.guids['ccUserDetails'] &&  Object.keys(this.guids['ccUserDetails']['ccGuids']).length > 1) {
      this.isCCMultipleGuid = Object.keys(this.guids['ccUserDetails']['ccGuids']).length > 1 ? true : false;
      for (const [key, value] of Object.entries(this.guids['ccUserDetails']['ccGuids'])) {

          multipleGuids.push(`${key}:\n${value}`);
        }
        this.guids['customerCentralMultipleGuids'] = multipleGuids.join('\n\n').toString();
      } else {
        this.isCCMultipleGuid = false;
        this.guids['customerCentralMultipleGuids'] = this.guids['customerCentralGuid'];
      }
    }
  /**
   * @function setVehicle Method to set the vehicle components and the flags associated
   */
  public setVehicleInfo(): void {
    this.vehicle = this.ngRedux.getState().selectedVehicle.vehicle;
    this.customerCentralFlag = (this.vehicle['generation'] === '17CY' && this.vehicle['region'] === 'CA') || this.vehicle['region'] === 'HI' ? false : true;
    this.subscriptionFlag = this.vehicle['generation'] === '17CY' || this.vehicle['generation'] === 'PRE17CY' ? false : true;
  }
}
